import { render, staticRenderFns } from "./PDFDownload.vue?vue&type=template&id=db5e6af4&"
import script from "./PDFDownload.vue?vue&type=script&lang=js&"
export * from "./PDFDownload.vue?vue&type=script&lang=js&"
import style0 from "./PDFDownload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "packages/cb-components-analyst-rating/src/components/analystRating/PDFDownload.vue"
export default component.exports